import React from 'react';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface CTABannerProps {
  title?: string;
  subtitle?: string;
  buttonLabel?: string;
  buttonLink?: string;
}

const CTABanner: React.FC<CTABannerProps> = ({
  title = 'Get A Free No-Obligation Quote Now!',
  subtitle = 'Quality medical equipment and healthcare supplies at highly competitive prices. CE Certified, FDA Approved.',
  buttonLabel = 'Request A Quote',
  buttonLink = '/contact',
}) => {
  return (
    <section className="relative py-12 sm:py-20 overflow-hidden">
      <img src="https://images.unsplash.com/photo-1538108149393-cebb47ac00f5?auto=format&fit=crop&q=80&w=2670" alt="Medical laboratory equipment background" className="absolute inset-0 w-full h-full object-cover opacity-20 mix-blend-overlay" />
      <div className="absolute inset-0 bg-primary/95" />
      <div className="container-main relative z-10 flex flex-col lg:flex-row items-center justify-between gap-6 sm:gap-8">
        <div className="text-center lg:text-left min-w-0">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white mb-2 sm:mb-3">{title}</h2>
          <p className="text-white/60 text-base sm:text-lg max-w-xl">{subtitle}</p>
        </div>
        <div className="flex-shrink-0 w-full sm:w-auto">
          <Link to={buttonLink} className="btn-primary text-base sm:text-lg px-8 sm:px-10 py-3.5 sm:py-4 shadow-xl min-h-[48px] inline-flex items-center justify-center w-full sm:w-auto">
            {buttonLabel} <ArrowForwardIcon />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
